import { parse, format, isValid } from 'date-fns';

import {
  FETCH_NAV_ATHLETES_START,
  FETCH_NAV_ATHLETES_FULFILLED,
  FETCH_NAV_ATHLETES_REJECTED,
  FETCH_NAV_ARCHIVED_ATHLETES_START,
  FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED,
  FETCH_NAV_ARCHIVED_ATHLETES_REJECTED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_START,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED,
  FETCH_NAV_ATHLETE_CALENDARS_START,
  FETCH_NAV_ATHLETE_CALENDARS_FULFILLED,
  FETCH_NAV_ATHLETE_CALENDARS_REJECTED,
  DELETE_NAV_ATHLETE_CALENDAR_START,
  DELETE_NAV_ATHLETE_CALENDAR_FULFILLED,
  DELETE_NAV_ATHLETE_CALENDAR_REJECTED,
  FETCH_NAV_ATHLETE_PROGRAMS_START,
  FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED,
  FETCH_NAV_ATHLETE_PROGRAMS_REJECTED,
  ASSIGN_NAV_ATHLETE_PROGRAMS_START,
  ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED,
  ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED,
  DELETE_NAV_ATHLETE_PROGRAM_START,
  DELETE_NAV_ATHLETE_PROGRAM_FULFILLED,
  DELETE_NAV_ATHLETE_PROGRAM_REJECTED,
  RESTART_NAV_ATHLETE_PROGRAM_START,
  RESTART_NAV_ATHLETE_PROGRAM_FULFILLED,
  RESTART_NAV_ATHLETE_PROGRAM_REJECTED,
  FETCH_NAV_CALENDARS_START,
  FETCH_NAV_CALENDARS_FULFILLED,
  FETCH_NAV_CALENDARS_REJECTED,
  FETCH_NAV_CALENDAR_ITEMS_START,
  FETCH_NAV_CALENDAR_ITEMS_FULFILLED,
  FETCH_NAV_CALENDAR_ITEMS_REJECTED,
  FETCH_NAV_CALENDAR_PREVIEW_START,
  FETCH_NAV_CALENDAR_PREVIEW_FULFILLED,
  FETCH_NAV_CALENDAR_PREVIEW_REJECTED,
  FETCH_NAV_GROUPS_START,
  FETCH_NAV_GROUPS_FULFILLED,
  FETCH_NAV_GROUPS_REJECTED,
  FETCH_NAV_PROGRAMS_START,
  FETCH_NAV_PROGRAMS_FULFILLED,
  FETCH_NAV_PROGRAMS_REJECTED,
  FETCH_NAV_PROGRAM_ITEMS_START,
  FETCH_NAV_PROGRAM_ITEMS_FULFILLED,
  FETCH_NAV_PROGRAM_ITEMS_REJECTED,
  FETCH_NAV_PROGRAM_DAY_ONE_START,
  FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED,
  FETCH_NAV_PROGRAM_DAY_ONE_REJECTED,
  FETCH_NAV_PROGRAM_PREVIEW_START,
  FETCH_NAV_PROGRAM_PREVIEW_FULFILLED,
  FETCH_NAV_PROGRAM_PREVIEW_REJECTED,
  FETCH_NAV_USER_START,
  FETCH_NAV_USER_FULFILLED,
  FETCH_NAV_USER_REJECTED,
  UPDATE_NAV_USER_START,
  UPDATE_NAV_USER_FULFILLED,
  UPDATE_NAV_USER_REJECTED,
  CREATE_NAV_USER_START,
  CREATE_NAV_USER_FULFILLED,
  CREATE_NAV_USER_REJECTED,
  DELETE_NAV_USERS_START,
  DELETE_NAV_USERS_FULFILLED,
  DELETE_NAV_USERS_REJECTED,
  RESEND_NAV_ACTIVATION_EMAIL_START,
  RESEND_NAV_ACTIVATION_EMAIL_FULFILLED,
  RESEND_NAV_ACTIVATION_EMAIL_REJECTED,
  ARCHIVE_NAV_USER_START,
  ARCHIVE_NAV_USER_FULFILLED,
  ARCHIVE_NAV_USER_REJECTED,
  UNARCHIVE_NAV_USER_START,
  UNARCHIVE_NAV_USER_FULFILLED,
  UNARCHIVE_NAV_USER_REJECTED,
  FETCH_NAV_WORKOUT_RESULTS_START,
  FETCH_NAV_WORKOUT_RESULTS_FULFILLED,
  FETCH_NAV_WORKOUT_RESULTS_REJECTED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_START,
  FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED,
  SET_IS_PREVIEW_CAROUSEL_SHOWING,
  BULK_UPDATE_GROUPS_START,
  BULK_UPDATE_GROUPS_FULFILLED,
  BULK_UPDATE_GROUPS_REJECTED,
  BULK_UPDATE_CALENDARS_START,
  BULK_UPDATE_CALENDARS_FULFILLED,
  BULK_UPDATE_CALENDARS_REJECTED,
  UPLOAD_NAV_USERS_START,
  UPLOAD_NAV_USERS_FULFILLED,
  UPLOAD_NAV_USERS_REJECTED,
  UPDATE_NAV_ATHLETE_IMAGE_START,
  UPDATE_NAV_ATHLETE_IMAGE_FULFILLED,
  UPDATE_NAV_ATHLETE_IMAGE_REJECTED,
  REMOVE_NAV_ATHLETE_IMAGE_START,
  REMOVE_NAV_ATHLETE_IMAGE_FULFILLED,
  REMOVE_NAV_ATHLETE_IMAGE_REJECTED,
} from './actionTypes';

import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';

const toApiDate = (dateStr) => {
  if (!dateStr) return null;
  const parsed = parse(dateStr, 'MM/dd/yyyy', new Date());
  return isValid(parsed) ? format(parsed, 'yyyy-MM-dd') : null;
};

export const fetchAthletes = (accountCode, filters = {}) => (dispatch) => {
  dispatch({ type: FETCH_NAV_ATHLETES_START });
  const params = new URLSearchParams({ userType: '0' });
  (filters.filterGroups || []).forEach((g) => params.append('filterGroups', g.id));
  (filters.filterCalendars || []).forEach((c) => params.append('filterCalendars', c.id));
  (filters.filterGenders || []).forEach((g) => params.append('filterGenders', g.id));
  if (filters.filterMode && filters.filterMode !== 'any') {
    params.append('filterMode', filters.filterMode);
  }
  axiosAuthed
    .get(`/accounts/${accountCode}/users?${params.toString()}`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_ATHLETES_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_ATHLETES_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load athletes',
      });
    });
};

export const fetchArchivedAthletes = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_NAV_ARCHIVED_ATHLETES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users/archived-users`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_ARCHIVED_ATHLETES_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load archived athletes',
      });
    });
};

export const fetchAthleteAssignments = (accountCode, userId) => (dispatch) => {
  dispatch({ type: FETCH_NAV_ATHLETE_ASSIGNMENTS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}/navigator/assignments`)
    .then((response) => {
      dispatch({ type: FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED, payload: response.data });
      return response.data;
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load athlete assignments',
      });
    });
};

export const fetchAthleteCalendars = (accountCode, userId) => (dispatch) => {
  dispatch({ type: FETCH_NAV_ATHLETE_CALENDARS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}/calendar`)
    .then((response) => {
      dispatch({ type: FETCH_NAV_ATHLETE_CALENDARS_FULFILLED, payload: response.data });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_ATHLETE_CALENDARS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load calendar history',
      });
    });
};

export const deleteAthleteCalendar = (
  accountCode,
  userId,
  assignmentId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: DELETE_NAV_ATHLETE_CALENDAR_START });
  axiosAuthed
    .patch(`/accounts/${accountCode}/users/${userId}/calendar/${assignmentId}`)
    .then((response) => {
      dispatch({ type: DELETE_NAV_ATHLETE_CALENDAR_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: DELETE_NAV_ATHLETE_CALENDAR_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to remove calendar assignment',
      });
      if (onError) onError(err);
    });
};

export const fetchAthletePrograms = (accountCode, userId) => (dispatch) => {
  dispatch({ type: FETCH_NAV_ATHLETE_PROGRAMS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}/day-based-workouts`, { params: { showRestrictedItems: true } })
    .then((response) => {
      dispatch({ type: FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED, payload: response.data });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_ATHLETE_PROGRAMS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load athlete programs',
      });
    });
};

export const assignAthletePrograms = (
  accountCode,
  userId,
  saveInfoIds,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: ASSIGN_NAV_ATHLETE_PROGRAMS_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/day-based-workouts`, { saveInfoIds })
    .then((response) => {
      dispatch({ type: ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to assign programs',
      });
      if (onError) onError(err);
    });
};

export const deleteAthleteProgram = (
  accountCode,
  dayBasedProgramId,
  userId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: DELETE_NAV_ATHLETE_PROGRAM_START });
  axiosAuthed
    .patch(`/accounts/${accountCode}/day-based-workouts/${dayBasedProgramId}/delete`, { userIds: [userId] })
    .then((response) => {
      dispatch({ type: DELETE_NAV_ATHLETE_PROGRAM_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: DELETE_NAV_ATHLETE_PROGRAM_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to delete program assignment',
      });
      if (onError) onError(err);
    });
};

export const restartAthleteProgram = (
  accountCode,
  userId,
  dayBasedProgramId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: RESTART_NAV_ATHLETE_PROGRAM_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/day-based-workouts/${dayBasedProgramId}`)
    .then((response) => {
      dispatch({ type: RESTART_NAV_ATHLETE_PROGRAM_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: RESTART_NAV_ATHLETE_PROGRAM_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to restart program',
      });
      if (onError) onError(err);
    });
};

export const fetchCalendars = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_NAV_CALENDARS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/navigator/calendar`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_CALENDARS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_CALENDARS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load calendars',
      });
    });
};

export const fetchCalendarItems = (accountCode, calendarId) => (dispatch) => {
  dispatch({ type: FETCH_NAV_CALENDAR_ITEMS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/navigator/calendar/${calendarId}`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_CALENDAR_ITEMS_FULFILLED,
        payload: {
          workoutItems: response.data.workoutSession?.workoutItems || [],
          workoutDate: response.data.workoutDate || null,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_CALENDAR_ITEMS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load calendar items',
      });
    });
};

export const fetchCalendarPreview = (
  currentUser,
  userId,
  startDate,
  endDate,
  showHiddenItems = false,
) => (dispatch) => {
  dispatch({ type: FETCH_NAV_CALENDAR_PREVIEW_START });

  let route;
  if (currentUser.id === userId) {
    route = `/me/accounts/${currentUser.accountCode}`;
  } else {
    route = `/accounts/${currentUser.accountCode}/users/${userId}`;
  }

  axiosAuthed
    .get(
      `${route}/workouts/overview?dateRangeStart=${startDate}&dateRangeEnd=${endDate}${showHiddenItems ? '&showHiddenItems=true' : ''}`,
      {
        requestId: 'fetchNavWorkoutCalendar',
      },
    )
    .then((response) => {
      dispatch({
        payload: response.data,
        type: FETCH_NAV_CALENDAR_PREVIEW_FULFILLED,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_CALENDAR_PREVIEW_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load calendar preview',
      });
    });
};

export const fetchGroups = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_NAV_GROUPS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/groups`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_GROUPS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_GROUPS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load groups',
      });
    });
};

export const fetchPrograms = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_NAV_PROGRAMS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/workouts/saved-workouts`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_PROGRAMS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_PROGRAMS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load programs',
      });
    });
};

export const fetchProgramItems = (
  accountCode,
  userId,
  dayBasedProgramId,
  dayNum,
) => (dispatch) => {
  dispatch({ type: FETCH_NAV_PROGRAM_ITEMS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}/day-based-workouts/${dayBasedProgramId}/days/${dayNum}`)
    .then((response) => {
      dispatch({ type: FETCH_NAV_PROGRAM_ITEMS_FULFILLED, payload: response.data });
      return response.data;
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_PROGRAM_ITEMS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load program items',
      });
    });
};

export const fetchProgramPreview = (accountCode, programId) => (dispatch) => {
  dispatch({ type: FETCH_NAV_PROGRAM_PREVIEW_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/workouts/saved-workouts/${programId}`)
    .then((response) => {
      const programItems = (response.data.programItems || [])
        .slice()
        .sort((a, b) => a.dayNumber - b.dayNumber)
        .filter((p) => Array.isArray(p.exercises) && p.exercises.length > 0);

      dispatch({
        type: FETCH_NAV_PROGRAM_PREVIEW_FULFILLED,
        payload: {
          programDays: programItems,
          initialDayIndex: 0,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_PROGRAM_PREVIEW_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load program preview',
      });
    });
};

export const fetchProgramDayOne = (
  currentUser,
  program,
  dayNum,
  userId,
  day = {},
) => (dispatch) => {
  dispatch({ type: FETCH_NAV_PROGRAM_DAY_ONE_START });

  let baseUrl;
  if (currentUser.id === userId) {
    baseUrl = `/me/accounts/${currentUser.accountCode}`;
  } else {
    baseUrl = `/accounts/${currentUser.accountCode}/users/${userId}`;
  }
  axiosAuthed
    .get(`${baseUrl}/day-based-workouts/${program.dayBasedProgramId}/days/${dayNum + 1}?organizeBySession=true`)
    .then((response) => {
      dispatch({
        payload: {
          data: response.data,
          dayIndex: dayNum + 1,
          day,
          program,
        },
        type: FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED,
      });
    })
    .catch((err) => {
      dispatch({
        payload: err?.response?.headers?.message || 'Unexpected error fetching workouts',
        type: FETCH_NAV_PROGRAM_DAY_ONE_REJECTED,
      });
    });
};

export const updateAthleteProfileImage = (
  accountCode,
  userId,
  acceptedFile,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: UPDATE_NAV_ATHLETE_IMAGE_START });
  const formData = new FormData();
  formData.append('image', Array.isArray(acceptedFile) ? acceptedFile[0] : acceptedFile);
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/profileImage`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      dispatch({ type: UPDATE_NAV_ATHLETE_IMAGE_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: UPDATE_NAV_ATHLETE_IMAGE_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to update profile image',
      });
      if (onError) onError(err);
    });
};

export const removeAthleteProfileImage = (
  accountCode,
  userId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: REMOVE_NAV_ATHLETE_IMAGE_START });
  axiosAuthed
    .delete(`/accounts/${accountCode}/users/${userId}/profileImage`)
    .then((response) => {
      dispatch({ type: REMOVE_NAV_ATHLETE_IMAGE_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: REMOVE_NAV_ATHLETE_IMAGE_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to remove profile image',
      });
      if (onError) onError(err);
    });
};

export const fetchUser = (accountCode, userId) => (dispatch) => {
  dispatch({ type: FETCH_NAV_USER_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_USER_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_USER_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to load user',
      });
    });
};

export const fetchWorkoutResults = (accountCode, userId, useAssignedDate = false) => (dispatch) => {
  dispatch({ type: FETCH_NAV_WORKOUT_RESULTS_START });

  const queryParam = useAssignedDate ? '?useAssignedDate=true' : '';
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}/navigator/workout-results${queryParam}`)
    .then((response) => {
      dispatch({
        type: FETCH_NAV_WORKOUT_RESULTS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_NAV_WORKOUT_RESULTS_REJECTED,
        payload: err?.response?.headers?.message || err?.response?.data || err?.message,
      });
    });
};

export const fetchWorkoutItemsByDate = (
  currentUser,
  userId,
  workoutDate,
  isAdditionalWorkouts = false,
  showHiddenItems = false,
  options = {},
) => (dispatch) => {
  dispatch({ type: FETCH_NAV_DAY_WORKOUT_ITEMS_START });

  let baseUrl;
  if (currentUser.id === userId) {
    baseUrl = `/me/accounts/${currentUser.accountCode}`;
  } else {
    baseUrl = `/accounts/${currentUser.accountCode}/users/${userId}`;
  }

  let url = `${baseUrl}/workouts/${workoutDate}?organizeBySession=true${showHiddenItems ? '&showHiddenItems=true' : ''}`;
  if (options.useNavigatorDate) {
    url += '&useNavigatorDate=true';
  }
  axiosAuthed
    .get(url)
    .then((response) => {
      dispatch({
        payload: {
          data: response.data,
          isAdditionalWorkouts,
        },
        type: FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED,
      });
    })
    .catch((err) => {
      dispatch({
        payload: err?.response?.headers?.message || 'Unexpected error fetching workouts',
        type: FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED,
      });
    });
};

export const updateUser = (
  accountCode,
  userId,
  values,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: UPDATE_NAV_USER_START });

  const body = {
    groupIds: (values.groups || []).map((g) => g.id),
    user: {
      firstName: values.first,
      lastName: values.last,
      ...(values.username ? { username: values.username } : { email: values.email }),
      mobileNumber: values.mobileNumber !== '' && values.mobileNumber != null ? String(values.mobileNumber) : '',
      countryCode: values.mobileCountry || '',
      gender: values.gender ? Number(values.gender.id) : 0,
      ssoId: values.ssoId || '',
      externalId: values.externalId || '',
      smartabaseId: values.smartabaseId || '',
      ...(values.changePassword && { password: values.changePassword }),
      ...(values.changePIN && { pin: values.changePIN }),
      ...(values.calendarVisibility != null && {
        calendarFutureHide: Number(values.calendarVisibility.id),
      }),
    },
    ...(values.calendarAssignment?.id != null && {
      calendar: {
        calendarId: values.calendarAssignment.id,
        ...(values.assignmentId != null && { assignmentId: values.assignmentId }),
        ...(values.startDate && { startDate: toApiDate(values.startDate) }),
        ...(values.endDate && { endDate: toApiDate(values.endDate) }),
        ...(values.dateOffset && { offsetDate: toApiDate(values.dateOffset) }),
      },
    }),
  };

  axiosAuthed
    .put(`/accounts/${accountCode}/users/${userId}`, body)
    .then((response) => {
      dispatch({
        type: UPDATE_NAV_USER_FULFILLED,
        payload: response.data,
      });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: UPDATE_NAV_USER_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to update athlete',
      });
      if (onError) onError(err);
    });
};

export const createUser = (
  accountCode,
  values,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: CREATE_NAV_USER_START });

  const body = {
    groupIds: (values.groups || []).map((g) => g.id),
    user: {
      firstName: values.first,
      lastName: values.last,
      ...(values.username ? { username: values.username } : { email: values.email }),
      ...(values.mobileNumber ? { mobileNumber: String(values.mobileNumber) } : {}),
      ...(values.mobileCountry ? { countryCode: values.mobileCountry } : {}),
      gender: values.gender ? Number(values.gender.id) : 0,
      ...(values.ssoId && { ssoId: values.ssoId }),
      ...(values.externalId && { externalId: values.externalId }),
      ...(values.smartabaseId && { smartabaseId: values.smartabaseId }),
      ...(values.changePassword ? { password: values.changePassword } : {}),
      ...(values.changePIN && { pin: values.changePIN }),
      ...(values.calendarVisibility != null && {
        calendarFutureHide: Number(values.calendarVisibility.id),
      }),
    },
    ...(values.calendarAssignment?.id != null && {
      calendar: {
        calendarId: values.calendarAssignment.id,
        ...(values.startDate && { startDate: toApiDate(values.startDate) }),
        ...(values.endDate && { endDate: toApiDate(values.endDate) }),
        ...(values.dateOffset && { offsetDate: toApiDate(values.dateOffset) }),
      },
    }),
    ...(values.contacts && values.contacts.length > 0 && {
      guardianContacts: values.contacts.map((c) => ({ fullName: c.name, email: c.email })),
    }),
  };

  axiosAuthed
    .post(`/accounts/${accountCode}/users`, body)
    .then((response) => {
      dispatch({ type: CREATE_NAV_USER_FULFILLED });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: CREATE_NAV_USER_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to create athlete',
      });
      if (onError) onError(err);
    });
};

export const deleteUsers = (accountCode, userIds, { onSuccess, onError } = {}) => (dispatch) => {
  dispatch({ type: DELETE_NAV_USERS_START });
  axiosAuthed
    .patch(`/accounts/${accountCode}/users/delete-users`, { userIds })
    .then((response) => {
      dispatch({ type: DELETE_NAV_USERS_FULFILLED, payload: userIds });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: DELETE_NAV_USERS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to delete athlete(s)',
      });
      if (onError) onError(err);
    });
};

export const bulkUpdateGroups = (
  accountCode,
  userIds,
  groupIds,
  mode,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: BULK_UPDATE_GROUPS_START });
  const method = mode === 'remove' ? 'patch' : 'put';
  const requests = groupIds.map((groupId) => axiosAuthed[method](
    `/accounts/${accountCode}/groups/${groupId}/user-detail`,
    { userIds },
  ));
  Promise.allSettled(requests)
    .then((results) => {
      const failures = results.filter((r) => r.status === 'rejected');
      if (failures.length === 0) {
        dispatch({ type: BULK_UPDATE_GROUPS_FULFILLED });
        if (onSuccess) onSuccess();
      } else {
        const firstError = failures[0].reason;
        dispatch({
          type: BULK_UPDATE_GROUPS_REJECTED,
          payload: firstError?.response?.headers?.message || 'One or more group updates failed',
        });
        if (onError) onError(firstError);
      }
    });
};

// TODO: replace with real endpoint once backend team provides it
export const moveUsers = (
  accountCode,
  userIds,
  newAccountCode,
  { onSuccess, onError } = {},
) => () => {
  axiosAuthed
    .put(`/accounts/${accountCode}/users/move-account`, { userIds, destinationAccountCode: newAccountCode })
    .then(() => { if (onSuccess) onSuccess(); })
    .catch((err) => { if (onError) onError(err); });
};

export const bulkEmailAssessments = (
  accountCode,
  userIds,
  recipientType,
  startDate,
  endDate,
  { onSuccess, onError } = {},
) => () => {
  axiosAuthed
    .post(`/accounts/${accountCode}/reports/report-card/send`, {
      userIds,
      audience: recipientType + 1,
      startDate: toApiDate(startDate),
      endDate: toApiDate(endDate),
    })
    .then(() => { if (onSuccess) onSuccess(); })
    .catch((err) => { if (onError) onError(err); });
};

export const bulkAssignPrograms = (
  accountCode,
  userIds,
  programIds,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: ASSIGN_NAV_ATHLETE_PROGRAMS_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/day-based-workouts`, {
      filterIds: userIds,
      filterType: 1,
      saveInfoIds: programIds,
    })
    .then((response) => {
      dispatch({ type: ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      dispatch({
        type: ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to assign programs',
      });
      if (onError) onError(err);
    });
};

export const bulkUpdateCalendars = (
  accountCode,
  userIds,
  calendarId,
  mode,
  dateStart,
  dateEnd,
  dateOffset,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: BULK_UPDATE_CALENDARS_START });

  let request;
  if (mode === 'end') {
    request = axiosAuthed.put(`/accounts/${accountCode}/calendars/end-assignments`, { userIds });
  } else {
    const body = {
      userIds,
      dateStart: toApiDate(dateStart),
      ...(dateEnd && { dateEnd: toApiDate(dateEnd) }),
      ...(dateOffset && { dateOffset: toApiDate(dateOffset) }),
    };
    request = axiosAuthed.put(`/accounts/${accountCode}/calendars/${calendarId}/users`, body);
  }

  request
    .then(() => {
      dispatch({ type: BULK_UPDATE_CALENDARS_FULFILLED });
      if (onSuccess) onSuccess();
    })
    .catch((err) => {
      dispatch({
        type: BULK_UPDATE_CALENDARS_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to update calendar assignments',
      });
      if (onError) onError(err);
    });
};

export const resendActivationEmail = (
  accountCode,
  userId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: RESEND_NAV_ACTIVATION_EMAIL_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/activation-email`, { customAuth: '' })
    .then((response) => {
      dispatch({ type: RESEND_NAV_ACTIVATION_EMAIL_FULFILLED, payload: response.data });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: RESEND_NAV_ACTIVATION_EMAIL_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to resend activation email',
      });
      if (onError) onError(err);
    });
};

export const archiveUser = (
  accountCode,
  userId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: ARCHIVE_NAV_USER_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/archive-user/archive`)
    .then((response) => {
      dispatch({ type: ARCHIVE_NAV_USER_FULFILLED, payload: userId });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: ARCHIVE_NAV_USER_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to archive athlete',
      });
      if (onError) onError(err);
    });
};

export const unarchiveUser = (
  accountCode,
  userId,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: UNARCHIVE_NAV_USER_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/archive-user/unarchive`)
    .then((response) => {
      dispatch({ type: UNARCHIVE_NAV_USER_FULFILLED, payload: userId });
      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      dispatch({
        type: UNARCHIVE_NAV_USER_REJECTED,
        payload: err?.response?.headers?.message || 'Unable to restore athlete',
      });
      if (onError) onError(err);
    });
};

export const setIsPreviewCarouselShowing = (bool) => (dispatch) => {
  dispatch({
    type: SET_IS_PREVIEW_CAROUSEL_SHOWING,
    payload: bool,
  });
};

export const fetchReportcardRecipients = (
  accountCode,
  userId,
  { onSuccess, onError } = {},
) => () => {
  axiosAuthed
    .get(`/accounts/${accountCode}/users/${userId}/reportcard-recipients`)
    .then((response) => { if (onSuccess) onSuccess(response.data); })
    .catch((err) => { if (onError) onError(err); });
};

export const createReportcardRecipient = (
  accountCode,
  userId,
  data,
  { onSuccess, onError } = {},
) => () => {
  axiosAuthed
    .post(`/accounts/${accountCode}/users/${userId}/reportcard-recipients`, data)
    .then((response) => { if (onSuccess) onSuccess(response.data); })
    .catch((err) => { if (onError) onError(err); });
};

export const updateReportcardRecipient = (
  accountCode,
  userId,
  recipientId,
  data,
  { onSuccess, onError } = {},
) => () => {
  axiosAuthed
    .put(`/accounts/${accountCode}/users/${userId}/reportcard-recipients/${recipientId}`, data)
    .then((response) => { if (onSuccess) onSuccess(response.data); })
    .catch((err) => { if (onError) onError(err); });
};

export const deleteReportcardRecipient = (
  accountCode,
  userId,
  recipientId,
  { onSuccess, onError } = {},
) => () => {
  axiosAuthed
    .delete(`/accounts/${accountCode}/users/${userId}/reportcard-recipients/${recipientId}`)
    .then(() => { if (onSuccess) onSuccess(); })
    .catch((err) => { if (onError) onError(err); });
};

export const uploadUsers = (accountCode, formData) => (dispatch) => {
  dispatch({ type: UPLOAD_NAV_USERS_START });
  return axiosAuthed
    .post(`/accounts/${accountCode}/users/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      dispatch({ type: UPLOAD_NAV_USERS_FULFILLED, payload: response.data });
      return response.data;
    })
    .catch((err) => {
      dispatch({ type: UPLOAD_NAV_USERS_REJECTED });
      throw err;
    });
};
